/**
 * Escapes `< > & "` so a string can be safely embedded inside a
 * `dangerouslySetInnerHTML` payload.
 *
 * Why this exists: React 19 serializes adjacent text→element→text JSX
 * children (e.g. `{prefix}{' '}<span>{italic}</span>`) with HTML boundary
 * comments (`<!-- -->`) at SSR. Browsers / in-app webviews that strip HTML
 * comments (Facebook IAB, some shopping crawlers) produce a DOM without
 * them, so React 19's byte-strict hydration comparison fires #418. The
 * canonical fix is to render the whole phrase as one continuous string via
 * `dangerouslySetInnerHTML` — no boundary comments for anything to strip.
 * Author-controlled i18n / data strings are escaped defensively so an
 * angle bracket in a value can never break out of the payload.
 *
 * See CLAUDE.md "Trigger H".
 */
export const escapeForHtml = (s: string): string =>
  s
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')

export default escapeForHtml
